import React from 'react';
import '../styles/social-club.scss';
import FeedContainer from './feed-container';

function SocialClub() {
  return (
    <div id='social-club'>
      <div className='topbar'>
        Club Feed

        {/* <UncontrolledDropdown size='sm'>
          <DropdownToggle caret tag="a">
            Latest Posts
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem>Latest</DropdownItem>
            <DropdownItem>Most Active</DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown> */}
      </div>
      <FeedContainer />
    </div>
  )
}

export default SocialClub;
